import { useCallback, useEffect, useMemo, useState } from "react";
import { GLANCE_UIS } from "../data/glanceUis";
import { glanceFullSrc, glanceTileSrc } from "../utils/media";

const API_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

function mergeGlanceItems(baseline, dynamic) {
  const seen = new Set(baseline.map((x) => x.src));
  const extra = (dynamic || []).filter((x) => x?.src && !seen.has(x.src));
  return [...baseline, ...extra];
}

export function useGlanceGallery() {
  const [dynamic, setDynamic] = useState([]);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const res = await fetch(`${API_URL}/api/glance`);
      const data = await res.json().catch(() => ({}));
      if (res.ok && Array.isArray(data.items)) {
        setDynamic(data.items);
      }
    } catch {
      /* offline or API down — baseline only */
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  const items = useMemo(() => mergeGlanceItems(GLANCE_UIS, dynamic), [dynamic]);

  const domeImages = useMemo(
    () =>
      items.map(({ src, title, href }) => ({
        src: glanceFullSrc(src),
        tile: glanceTileSrc(src),
        alt: title,
        href: href || "",
      })),
    [items]
  );

  return { items, domeImages, count: items.length, loaded, refresh };
}
